import {
  Companion_getInstance28gwov6pby7lz as Companion_getInstance,
  PayAppItemz8p3l02jgtr9 as PayAppItem,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  AccessInfoj60d6hx1qs8r as AccessInfo,
  AccessAndFeedback14j91frzc8fa0 as AccessAndFeedback,
} from './supportModels.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(PayAppItem_project_getInstance());
}
function get_amount(_this__u8e3s4) {
  return _this__u8e3s4.prop(PayAppItem_amount_getInstance());
}
function get__id(_this__u8e3s4) {
  return _this__u8e3s4.prop(PayAppItem__id_getInstance());
}
function preparePayAppItemFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [PayAppItem__id_getInstance(), PayAppItem_payApp_getInstance(), PayAppItem_lineItem_getInstance(), PayAppItem_amount_getInstance(), PayAppItem_approved_getInstance(), PayAppItem_denied_getInstance(), PayAppItem_voided_getInstance(), PayAppItem_project_getInstance(), PayAppItem_submitted_getInstance(), PayAppItem_accepted_getInstance(), PayAppItem_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function PayAppItem_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function PayAppItem_project$_get_name_$ref_a87ssz() {
  return (p0) => p0.k20();
}
function PayAppItem_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_project$_get_serializer_$ref_23lu9y() {
  return (p0) => p0.j2j();
}
function PayAppItem_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function PayAppItem_project$_get_annotations_$ref_m101xe() {
  return (p0) => p0.bz();
}
var PayAppItem_projectClass;
function PayAppItem_project() {
  if (PayAppItem_projectClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_project_instance = this;
        var tmp = this;
        tmp.m6v_1 = lazy(PayAppItem_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n6v_1 = lazy(PayAppItem_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o6v_1 = lazy(PayAppItem_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m6v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_project$_get_name_$ref_a87ssz(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.x6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      c6w(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.c6w(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n6v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_project$_get_serializer_$ref_23lu9y(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o6v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_project$_get_annotations_$ref_m101xe(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_project', VOID, VOID, [SerializableProperty()]);
    PayAppItem_projectClass = $;
  }
  return PayAppItem_projectClass;
}
var PayAppItem_project_instance;
function PayAppItem_project_getInstance() {
  if (PayAppItem_project_instance === VOID)
    new (PayAppItem_project())();
  return PayAppItem_project_instance;
}
function PayAppItem_amount$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function PayAppItem_amount$_get_name_$ref_qh51iw() {
  return (p0) => p0.k20();
}
function PayAppItem_amount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_amount$_get_serializer_$ref_5d3twf() {
  return (p0) => p0.j2j();
}
function PayAppItem_amount$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function PayAppItem_amount$_get_annotations_$ref_upcchv() {
  return (p0) => p0.bz();
}
var PayAppItem_amountClass;
function PayAppItem_amount() {
  if (PayAppItem_amountClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_amount_instance = this;
        var tmp = this;
        tmp.e6w_1 = lazy(PayAppItem_amount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f6w_1 = lazy(PayAppItem_amount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g6w_1 = lazy(PayAppItem_amount$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.e6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_amount$_get_name_$ref_qh51iw(), null);
        return tmp0.f2();
      }
      h6w(receiver) {
        return receiver.t6v_1;
      }
      m2j(receiver) {
        return new (MonetaryValue())(this.h6w(receiver instanceof PayAppItem() ? receiver : THROW_CCE()));
      }
      i6w(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.i6w(tmp, value instanceof MonetaryValue() ? value.a5s_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_amount$_get_serializer_$ref_5d3twf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_amount$_get_annotations_$ref_upcchv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_amount', VOID, VOID, [SerializableProperty()]);
    PayAppItem_amountClass = $;
  }
  return PayAppItem_amountClass;
}
var PayAppItem_amount_instance;
function PayAppItem_amount_getInstance() {
  if (PayAppItem_amount_instance === VOID)
    new (PayAppItem_amount())();
  return PayAppItem_amount_instance;
}
function PayAppItem__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function PayAppItem__id$_get_name_$ref_gpupt8() {
  return (p0) => p0.k20();
}
function PayAppItem__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem__id$_get_serializer_$ref_zgbm6d() {
  return (p0) => p0.j2j();
}
function PayAppItem__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function PayAppItem__id$_get_annotations_$ref_hhm7bz() {
  return (p0) => p0.bz();
}
var PayAppItem__idClass;
function PayAppItem__id() {
  if (PayAppItem__idClass === VOID) {
    class $ {
      constructor() {
        PayAppItem__id_instance = this;
        var tmp = this;
        tmp.j6w_1 = lazy(PayAppItem__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k6w_1 = lazy(PayAppItem__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l6w_1 = lazy(PayAppItem__id$annotations$delegate$lambda);
        this.m6w_1 = Companion_getInstance_0().m2p();
        this.n6w_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.j6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem__id$_get_name_$ref_gpupt8(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.q6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      c6w(receiver, value) {
        return receiver.d6w(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.c6w(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem__id$_get_serializer_$ref_zgbm6d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem__id$_get_annotations_$ref_hhm7bz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem__id', VOID, VOID, [SerializableProperty()]);
    PayAppItem__idClass = $;
  }
  return PayAppItem__idClass;
}
var PayAppItem__id_instance;
function PayAppItem__id_getInstance() {
  if (PayAppItem__id_instance === VOID)
    new (PayAppItem__id())();
  return PayAppItem__id_instance;
}
function PayAppItem_payApp$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function PayAppItem_payApp$_get_name_$ref_jyxk49() {
  return (p0) => p0.k20();
}
function PayAppItem_payApp$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_payApp$_get_serializer_$ref_oxzzpc() {
  return (p0) => p0.j2j();
}
function PayAppItem_payApp$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function PayAppItem_payApp$_get_annotations_$ref_81g7lo() {
  return (p0) => p0.bz();
}
var PayAppItem_payAppClass;
function PayAppItem_payApp() {
  if (PayAppItem_payAppClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_payApp_instance = this;
        var tmp = this;
        tmp.o6w_1 = lazy(PayAppItem_payApp$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p6w_1 = lazy(PayAppItem_payApp$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q6w_1 = lazy(PayAppItem_payApp$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.o6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_payApp$_get_name_$ref_jyxk49(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.r6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      c6w(receiver, value) {
        return receiver.d6w(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.c6w(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_payApp$_get_serializer_$ref_oxzzpc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_payApp$_get_annotations_$ref_81g7lo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_payApp', VOID, VOID, [SerializableProperty()]);
    PayAppItem_payAppClass = $;
  }
  return PayAppItem_payAppClass;
}
var PayAppItem_payApp_instance;
function PayAppItem_payApp_getInstance() {
  if (PayAppItem_payApp_instance === VOID)
    new (PayAppItem_payApp())();
  return PayAppItem_payApp_instance;
}
function PayAppItem_lineItem$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function PayAppItem_lineItem$_get_name_$ref_8xxf6h() {
  return (p0) => p0.k20();
}
function PayAppItem_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_lineItem$_get_serializer_$ref_smyn8y() {
  return (p0) => p0.j2j();
}
function PayAppItem_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function PayAppItem_lineItem$_get_annotations_$ref_jasahe() {
  return (p0) => p0.bz();
}
var PayAppItem_lineItemClass;
function PayAppItem_lineItem() {
  if (PayAppItem_lineItemClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_lineItem_instance = this;
        var tmp = this;
        tmp.r6w_1 = lazy(PayAppItem_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s6w_1 = lazy(PayAppItem_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t6w_1 = lazy(PayAppItem_lineItem$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_lineItem$_get_name_$ref_8xxf6h(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.s6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      c6w(receiver, value) {
        return receiver.d6w(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.c6w(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_lineItem$_get_serializer_$ref_smyn8y(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_lineItem$_get_annotations_$ref_jasahe(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_lineItem', VOID, VOID, [SerializableProperty()]);
    PayAppItem_lineItemClass = $;
  }
  return PayAppItem_lineItemClass;
}
var PayAppItem_lineItem_instance;
function PayAppItem_lineItem_getInstance() {
  if (PayAppItem_lineItem_instance === VOID)
    new (PayAppItem_lineItem())();
  return PayAppItem_lineItem_instance;
}
function PayAppItem_approved$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function PayAppItem_approved$_get_name_$ref_rm66bb() {
  return (p0) => p0.k20();
}
function PayAppItem_approved$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_approved$_get_serializer_$ref_raft5q() {
  return (p0) => p0.j2j();
}
function PayAppItem_approved$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function PayAppItem_approved$_get_annotations_$ref_9pyiqm() {
  return (p0) => p0.bz();
}
var PayAppItem_approvedClass;
function PayAppItem_approved() {
  if (PayAppItem_approvedClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_approved_instance = this;
        var tmp = this;
        tmp.u6w_1 = lazy(PayAppItem_approved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v6w_1 = lazy(PayAppItem_approved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w6w_1 = lazy(PayAppItem_approved$annotations$delegate$lambda);
        this.x6w_1 = null;
        this.y6w_1 = 'null';
      }
      k20() {
        var tmp0 = this.u6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_approved$_get_name_$ref_rm66bb(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.u6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      z6w(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.z6w(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_approved$_get_serializer_$ref_raft5q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w6w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_approved$_get_annotations_$ref_9pyiqm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_approved', VOID, VOID, [SerializableProperty()]);
    PayAppItem_approvedClass = $;
  }
  return PayAppItem_approvedClass;
}
var PayAppItem_approved_instance;
function PayAppItem_approved_getInstance() {
  if (PayAppItem_approved_instance === VOID)
    new (PayAppItem_approved())();
  return PayAppItem_approved_instance;
}
function PayAppItem_denied$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function PayAppItem_denied$_get_name_$ref_thl9qz() {
  return (p0) => p0.k20();
}
function PayAppItem_denied$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_denied$_get_serializer_$ref_dq2h6m() {
  return (p0) => p0.j2j();
}
function PayAppItem_denied$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function PayAppItem_denied$_get_annotations_$ref_gu8loa() {
  return (p0) => p0.bz();
}
var PayAppItem_deniedClass;
function PayAppItem_denied() {
  if (PayAppItem_deniedClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_denied_instance = this;
        var tmp = this;
        tmp.a6x_1 = lazy(PayAppItem_denied$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b6x_1 = lazy(PayAppItem_denied$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c6x_1 = lazy(PayAppItem_denied$annotations$delegate$lambda);
        this.d6x_1 = null;
        this.e6x_1 = 'null';
      }
      k20() {
        var tmp0 = this.a6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_denied$_get_name_$ref_thl9qz(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.v6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      f6x(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.f6x(tmp, (value == null ? true : value instanceof AccessAndFeedback()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_denied$_get_serializer_$ref_dq2h6m(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_denied$_get_annotations_$ref_gu8loa(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_denied', VOID, VOID, [SerializableProperty()]);
    PayAppItem_deniedClass = $;
  }
  return PayAppItem_deniedClass;
}
var PayAppItem_denied_instance;
function PayAppItem_denied_getInstance() {
  if (PayAppItem_denied_instance === VOID)
    new (PayAppItem_denied())();
  return PayAppItem_denied_instance;
}
function PayAppItem_voided$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function PayAppItem_voided$_get_name_$ref_nyth6b() {
  return (p0) => p0.k20();
}
function PayAppItem_voided$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_voided$_get_serializer_$ref_esm9ei() {
  return (p0) => p0.j2j();
}
function PayAppItem_voided$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function PayAppItem_voided$_get_annotations_$ref_mgx7tq() {
  return (p0) => p0.bz();
}
var PayAppItem_voidedClass;
function PayAppItem_voided() {
  if (PayAppItem_voidedClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_voided_instance = this;
        var tmp = this;
        tmp.g6x_1 = lazy(PayAppItem_voided$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h6x_1 = lazy(PayAppItem_voided$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i6x_1 = lazy(PayAppItem_voided$annotations$delegate$lambda);
        this.j6x_1 = null;
        this.k6x_1 = 'null';
      }
      k20() {
        var tmp0 = this.g6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_voided$_get_name_$ref_nyth6b(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.w6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      z6w(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.z6w(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_voided$_get_serializer_$ref_esm9ei(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_voided$_get_annotations_$ref_mgx7tq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_voided', VOID, VOID, [SerializableProperty()]);
    PayAppItem_voidedClass = $;
  }
  return PayAppItem_voidedClass;
}
var PayAppItem_voided_instance;
function PayAppItem_voided_getInstance() {
  if (PayAppItem_voided_instance === VOID)
    new (PayAppItem_voided())();
  return PayAppItem_voided_instance;
}
function PayAppItem_submitted$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function PayAppItem_submitted$_get_name_$ref_sgc6lx() {
  return (p0) => p0.k20();
}
function PayAppItem_submitted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_submitted$_get_serializer_$ref_brf3do() {
  return (p0) => p0.j2j();
}
function PayAppItem_submitted$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function PayAppItem_submitted$_get_annotations_$ref_pk4peo() {
  return (p0) => p0.bz();
}
var PayAppItem_submittedClass;
function PayAppItem_submitted() {
  if (PayAppItem_submittedClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_submitted_instance = this;
        var tmp = this;
        tmp.l6x_1 = lazy(PayAppItem_submitted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m6x_1 = lazy(PayAppItem_submitted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n6x_1 = lazy(PayAppItem_submitted$annotations$delegate$lambda);
        this.o6x_1 = null;
        this.p6x_1 = 'null';
      }
      k20() {
        var tmp0 = this.l6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_submitted$_get_name_$ref_sgc6lx(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.y6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      q6x(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.q6x(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_submitted$_get_serializer_$ref_brf3do(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_submitted$_get_annotations_$ref_pk4peo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_submitted', VOID, VOID, [SerializableProperty()]);
    PayAppItem_submittedClass = $;
  }
  return PayAppItem_submittedClass;
}
var PayAppItem_submitted_instance;
function PayAppItem_submitted_getInstance() {
  if (PayAppItem_submitted_instance === VOID)
    new (PayAppItem_submitted())();
  return PayAppItem_submitted_instance;
}
function PayAppItem_accepted$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function PayAppItem_accepted$_get_name_$ref_p6s12f() {
  return (p0) => p0.k20();
}
function PayAppItem_accepted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_accepted$_get_serializer_$ref_4z964u() {
  return (p0) => p0.j2j();
}
function PayAppItem_accepted$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function PayAppItem_accepted$_get_annotations_$ref_sed8q6() {
  return (p0) => p0.bz();
}
var PayAppItem_acceptedClass;
function PayAppItem_accepted() {
  if (PayAppItem_acceptedClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_accepted_instance = this;
        var tmp = this;
        tmp.r6x_1 = lazy(PayAppItem_accepted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s6x_1 = lazy(PayAppItem_accepted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t6x_1 = lazy(PayAppItem_accepted$annotations$delegate$lambda);
        this.u6x_1 = null;
        this.v6x_1 = 'null';
      }
      k20() {
        var tmp0 = this.r6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_accepted$_get_name_$ref_p6s12f(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.z6v_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      w6x(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.w6x(tmp, (value == null ? true : typeof value === 'boolean') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_accepted$_get_serializer_$ref_4z964u(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_accepted$_get_annotations_$ref_sed8q6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_accepted', VOID, VOID, [SerializableProperty()]);
    PayAppItem_acceptedClass = $;
  }
  return PayAppItem_acceptedClass;
}
var PayAppItem_accepted_instance;
function PayAppItem_accepted_getInstance() {
  if (PayAppItem_accepted_instance === VOID)
    new (PayAppItem_accepted())();
  return PayAppItem_accepted_instance;
}
function PayAppItem_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function PayAppItem_readBy$_get_name_$ref_x3wy0j() {
  return (p0) => p0.k20();
}
function PayAppItem_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PayAppItem_readBy$_get_serializer_$ref_tis7qs() {
  return (p0) => p0.j2j();
}
function PayAppItem_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function PayAppItem_readBy$_get_annotations_$ref_7vj0w8() {
  return (p0) => p0.bz();
}
var PayAppItem_readByClass;
function PayAppItem_readBy() {
  if (PayAppItem_readByClass === VOID) {
    class $ {
      constructor() {
        PayAppItem_readBy_instance = this;
        var tmp = this;
        tmp.x6x_1 = lazy(PayAppItem_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6x_1 = lazy(PayAppItem_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6x_1 = lazy(PayAppItem_readBy$annotations$delegate$lambda);
        this.a6y_1 = emptySet();
        this.b6y_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.x6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PayAppItem_readBy$_get_name_$ref_x3wy0j(), null);
        return tmp0.f2();
      }
      p6v(receiver) {
        return receiver.a6w_1;
      }
      m2j(receiver) {
        return this.p6v(receiver instanceof PayAppItem() ? receiver : THROW_CCE());
      }
      c6y(receiver, value) {
        return receiver.d6w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PayAppItem() ? receiver : THROW_CCE();
        return this.c6y(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PayAppItem_readBy$_get_serializer_$ref_tis7qs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PayAppItem_readBy$_get_annotations_$ref_7vj0w8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PayAppItem_readBy', VOID, VOID, [SerializableProperty()]);
    PayAppItem_readByClass = $;
  }
  return PayAppItem_readByClass;
}
var PayAppItem_readBy_instance;
function PayAppItem_readBy_getInstance() {
  if (PayAppItem_readBy_instance === VOID)
    new (PayAppItem_readBy())();
  return PayAppItem_readBy_instance;
}
//region block: exports
export {
  get__id as get__id1xznbeynjgj8x,
  get_amount as get_amount297a4togm1x48,
  preparePayAppItemFields as preparePayAppItemFieldsz9ai2rbsqcik,
  get_project as get_project2kz1aoxt3unwl,
};
//endregion

//# sourceMappingURL=PayAppItemFields.mjs.map
